'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {togglePin, togglePinSuccess, togglePinError} from '../actions';
import {USER_PRIORITIES_COLLECTION} from '../domain/config';
import {logger} from './logger';


export const epics = [
  onTogglePin,
];

onTogglePin.$inject = [
  'fetchUtils',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable<ReduxAction>}
 */
export function onTogglePin(action$, store, dependencies) {
  return action$.ofType(togglePin.TYPE)
    .mergeMap(action => requestTogglePin(action.payload.id, action.payload.priority))
    .catch(epicErrorHandler(logger, 'onTogglePin'));

  /**
   * @param {String} id
   * @param {Number} priority
   * @return {Observable<ReduxAction>}
   */
  function requestTogglePin(id, priority) {
    const request = {
      method: 'PATCH',
      mode: 'cors',
      cache: 'default',
      contentType: 'json',
      responseType: 'json',
      body: {
        priority,
      },
    };

    const url = `${dependencies.fetchUtils.API_URL}/api/${USER_PRIORITIES_COLLECTION}/${id}`;
    return Observable.fromPromise(dependencies.fetchUtils.requestWithAuth(url, request)
      .then(rawResponse => togglePinSuccess({id, priority}))
      .catch(err => {
        logger.error({err}, 'Failed to sweep list');
        return togglePinError(id, err);
      }));
  }
}



// WEBPACK FOOTER //
// ./src/js/priorities/epics/onTogglePin.js